import React from 'react';

import {PrimaryButton} from 'Components/Button';
import {Alert} from 'Components/Partials';
import {Link} from 'Components/Utilities';

export default class AuthLayout extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            title,
            children,
            backLink = null,
            backLinkText = null,
            submitText,
            onSubmit,
            working,
            alert
        } = this.props;

        return (
            <div className="w-full md:w-3/4 lg:w-1/2 mx-auto">
                <h1 className="text-center text-6xl text-app-blue mt-8 lg:mt-20 mb-12">
                    {title}
                </h1>

                {/*<p className={"text-center text-white text-lg mb-12"}>*/}
                {/*    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam nec purus et nunc.*/}
                {/*</p>*/}

                <form autoComplete="off" onSubmit={onSubmit}>
                    {alert !== null && (<Alert {...alert} />)}

                    {children}

                    <div className="text-center my-12">
                        <PrimaryButton
                            text={submitText}
                            working={working}
                        />
                    </div>
                </form>

                {backLink &&
                    <div className="text-center my-12 text-app-blue">
                        <Link to={backLink} colour={"white"}>
                            {backLinkText}
                        </Link>
                    </div>
                }
            </div>
        );
    }
}
